import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { IDocument } from './document-upload-list.models';

@Component({
    selector: 'app-document-upload-list',
    templateUrl: './document-upload-list.component.html',
    styleUrls: ['./document-upload-list.component.scss'],
    standalone: false
})
export class DocumentUploadListComponent implements OnInit {

  @Input() documents: IDocument[];
  @Input('can-delete') set canDelete(value: boolean){
    if(value)
      this.displayedColumns = [...this.displayColumns, 'actions'];
    else
      this.displayedColumns = this.displayColumns;
  };
  @Output() deleted = new EventEmitter<string>();

  @Input() requestFiles: boolean;
  @Output() fileRequested = new EventEmitter<IDocument>();

  dataSource: MatTableDataSource<any>;
  private displayColumns = ['friendlyName', 'fileName'];
  displayedColumns = this.displayColumns;
  
  @ViewChild('verifyDelete') verifyDeleteWarning: TemplateRef<any>;

  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  confirmDeleteDocument(document: IDocument) {
    this.dialog
      .open(this.verifyDeleteWarning, {
        width: '400px',
        data: document,
      })
      .afterClosed()
      .subscribe(() => {});
  }

  onDeleteDocument(document: IDocument) {
    this.deleted.emit(document.id);
  }
}
